module.exports = __webpack_public_path__ + "img/smart-packaging-offline.110bf5c1.png";